export default "__VITE_ASSET__CUTqarAS__"